import { QuestionNode } from '../../../actionCard'

export class PhoneQuestionNode extends QuestionNode {}
